import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Checkbox, Collapse, Input, message } from 'antd'
import { inject, observer } from 'mobx-react'
import { CaretRightOutlined, SearchOutlined } from '@ant-design/icons'
// import { blue } from '../../../../color'
import { useParams } from 'react-router-dom'
import { BoxWrapper } from '../../components/SelectPeoplePopup/SelectUserDepartmentBox/SelectUserDepartmentBoxStyled'
import { PanelItem } from '../../components/SelectGroupPopupTruc/SelectGroupBoxTruc/SelectGroupBoxTrucStyled'
import { blue } from '../../color'
import { AvatarHasName } from '../../components/Common/Avatar'
import { EmptyText } from '../../components/Common/CellText'
import { ASSIGNEE_TYPE } from '../../constants'
import { useUpdatingRiskExecutor } from '../RiskDetailPage/hooks/useUpdatingRiskExecutor'

const SelectGroupBox = props => {
  const {
    selectPeopleStore,
    disableGroupList,
    loadingAnimationStore,
    onlySelectOne,
    onlySelectUser,
    isVisibleSelectGroupPopup,
    riskStore,
    riskUnitUserStore,
    departmentStore,
    userStore
  } = props

  const {
    groupList,
    setGroupList,
    originGroupList,
    assigneePopupType,
    selectGroupData,
    setSelectGroupData,
    selectUserData,
    setSelectUserData,
    selectDepartmentData,
    setSelectDepartmentData,
  } = selectPeopleStore
  const { riskId } = useParams()
  const { departmentList } = departmentStore
  const { userWithDepartment } = userStore
  const {
    updateTier1RiskExecutor,
    updateTier2RiskExecutor,
    updateTier3RiskExecutor,
  } = useUpdatingRiskExecutor({
    riskStore,
    riskUnitUserStore,
    loadingAnimationStore,
    type: 'CQVP',
    riskId,
  })

  useEffect(() => {
    ; (async () => {
      await updateTier3RiskExecutor
      await departmentStore.getDepartmentList()
      await userStore.getUserListV2()
    })()
  }, [assigneePopupType, originGroupList])

  function convertCodeOrCodesToDepartName(input) {
    const codes = input?.split(',').map(code => code.trim())
    const names = codes?.map(code => {
      const role = departmentList?.find(role => role.code === code)
      return role ? role?.name : 'Không tìm thấy phòng ban'
    })
    return names?.join(', ')
  }

  function convertCodeOrCodesToNameFromDepartUser(currentUser) {
    const input = userWithDepartment?.find(user => user.username === currentUser)
      ?.department
    const codes = input?.split(',').map(code => code.trim())
    const names = codes?.map(code => {
      const role = departmentList?.find(role => role.code === code)
      return role ? role?.name : 'Không tìm thấy phòng ban'
    })
    return names?.join(', ')
  }

  const handleSelectGroup = useCallback(
    (group, isChecked, event) => {
      event?.stopPropagation()

      if (!assigneePopupType || !group) return

      const newSelectGroupData = { ...selectGroupData }
      const newSelectUserData = { ...selectUserData }

      // Đảm bảo mảng tồn tại cho assigneePopupType
      if (!newSelectGroupData[assigneePopupType]) {
        newSelectGroupData[assigneePopupType] = []
      }
      if (!newSelectUserData[assigneePopupType]) {
        newSelectUserData[assigneePopupType] = []
      }

      if (isChecked) {
        // Xử lý khi tick vào group
        if (onlySelectOne) {
          // Nếu chỉ được chọn một, reset toàn bộ dữ liệu cũ
          newSelectGroupData[assigneePopupType] = [
            {
              assignee_type: ASSIGNEE_TYPE.GROUP,
              full_name: group.name,
              id: group.id.toString(),
              permission: assigneePopupType,
            },
          ]
          newSelectUserData[assigneePopupType] = []
        } else {
          // Thêm group mới vào danh sách đã chọn
          const existingGroupIndex = newSelectGroupData[
            assigneePopupType
          ].findIndex(g => g.id === group.id.toString())

          if (existingGroupIndex === -1) {
            newSelectGroupData[assigneePopupType].push({
              assignee_type: ASSIGNEE_TYPE.GROUP,
              full_name: group.name,
              id: group.id.toString(),
              permission: assigneePopupType,
            })
          }
        }
      } else {
        // Xử lý khi untick group
        // 1. Xóa group khỏi danh sách đã chọn
        newSelectGroupData[assigneePopupType] = newSelectGroupData[
          assigneePopupType
        ].filter(g => g.id !== group.id.toString())

        // 2. Xóa tất cả users thuộc group này khỏi selectUserData
        const groupUserIds = group.users.map(u => u.id.toString())
        newSelectUserData[assigneePopupType] = newSelectUserData[
          assigneePopupType
        ].filter(user => !groupUserIds.includes(user.id))
      }

      // Cập nhật state
      setSelectGroupData(newSelectGroupData)
      setSelectUserData(newSelectUserData)
    },
    [assigneePopupType, selectGroupData, selectUserData, onlySelectOne]
  )

  const handleSelectUser = useCallback(
    (user, group, isChecked, event) => {
      event?.stopPropagation()

      if (!assigneePopupType || !user) return

      const newSelectUserData = { ...selectUserData }

      // Đảm bảo mảng tồn tại cho assigneePopupType
      if (!newSelectUserData[assigneePopupType]) {
        newSelectUserData[assigneePopupType] = []
      }

      if (isChecked) {
        if (onlySelectOne && !onlySelectUser) {
          // Nếu chỉ được chọn một user và không chọn nhiều user
          newSelectUserData[assigneePopupType] = [
            {
              id: user.user.user_name.toString(),
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: user.user.name_lowercase,
              image_id: user.image,
              permission: assigneePopupType,
            },
          ]
        } else if (onlySelectUser) {
          // Nếu `onlySelectUser` là true, cho phép chọn nhiều user
          const existingUserIndex = newSelectUserData[
            assigneePopupType
          ].findIndex(u => u.id === user.user.user_name.toString())

          if (existingUserIndex === -1) {
            newSelectUserData[assigneePopupType].push({
              id: user.user.user_name.toString(),
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: user.user.name_lowercase,
              image_id: user.image,
              permission: assigneePopupType,
            })
          }
        }
      } else {
        // Xóa user khỏi danh sách đã chọn
        newSelectUserData[assigneePopupType] = newSelectUserData[
          assigneePopupType
        ].filter(item => item.id !== user.user.user_name.toString())
      }

      setSelectUserData(newSelectUserData)
    },
    [assigneePopupType, selectUserData, onlySelectOne, onlySelectUser]
  )

  const handleSearchGroup = useCallback(
    event => {
      setValueSearch(event.target.value)
      if (event.target.value.trim() === '') {
        setGroupList(originGroupList)
        return
      }
      const listGroupFilter = originGroupList.filter(group =>
        utils
          .nonAccentVietnamese(group.name)
          .includes(utils.nonAccentVietnamese(event.target.value))
      )
      setGroupList(listGroupFilter)
    },
    [originGroupList]
  )

  const [valueSearch, setValueSearch] = useState('')

  const handleOpenGroup = async group => {
    if (
      !group ||
      groupList.find(el => parseInt(el.id) === parseInt(group.id)).users
        .length > 0
    )
      return
    try {
      loadingAnimationStore.setShowSpinInline(true)
      await selectPeopleStore.getMemberGroup(group.id)
    } catch (err) {
      // message.error(err.vi || 'Đã có lỗi xảy ra!')
      // console.log(err)
    } finally {
      loadingAnimationStore.setShowSpinInline(false)
    }
  }

  const prevOriginGroupListRef = useRef([])
  useEffect(() => {
    if (
      JSON.stringify(prevOriginGroupListRef.current) ===
      JSON.stringify(originGroupList)
    ) {
      return
    }

    prevOriginGroupListRef.current = originGroupList

    const fetchAllGroupMembers = async () => {
      try {
        // loadingAnimationStore.setShowSpinInline(true)
        await Promise.all(
          originGroupList.map(group =>
            selectPeopleStore.getMemberGroup(group.id)
          )
        )
      } catch (err) {
        // message.error(err.vi || 'Đã có lỗi xảy ra!')
        // console.log(err)
      } finally {
        // loadingAnimationStore.setShowSpinInline(false)
      }
    }

    fetchAllGroupMembers()
  }, [originGroupList, loadingAnimationStore, selectPeopleStore])

  // const isUserSelectedInGroup = selectGroupData[assigneePopupType]
  //   ?.find(g => g.id === group.id)
  //   ?.users?.find(u => u.id === user.id)?.selected

  // const isUserChecked =
  //   isGroupChecked || isUserIndividuallySelected || isUserSelectedInGroup

  return (
    <BoxWrapper>
      <div className={'search-box'}>
        <label style={{ fontWeight: 500, marginRight: 10 }}>
          <SearchOutlined style={{ marginRight: 4, color: blue }} />
          Tìm kiếm:
        </label>
        <Input
          placeholder={'Nhập tên nhóm...'}
          style={{ width: 300 }}
          onChange={event => handleSearchGroup(event)}
          value={valueSearch}
        />
      </div>
      <div className={'collapse-wrapper'}>
        <Collapse
          defaultActiveKey={groupList.map(group => group.id)}
          collapsible={'header'}
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}>
          {groupList.map(group => {
            // Kiểm tra xem group có được chọn hay không
            const isGroupChecked =
              assigneePopupType &&
              selectGroupData[assigneePopupType]?.some(
                el => el.id === group.id.toString()
              )

            const disabled =
              disableGroupList.includes(group.id) ||
              disableGroupList.includes(group.id.toString())

            return (
              <PanelItem
                key={group.id}
                header={
                  <div
                    className={`group-item ${isGroupChecked ? 'group-item-checked' : ''
                      } ${disabled ? 'group-item-disabled' : ''}`}
                    onClick={e => e.stopPropagation()}>
                    {!onlySelectOne && !onlySelectUser && (
                      <Checkbox
                        checked={isGroupChecked}
                        disabled={disabled}
                        onChange={e =>
                          handleSelectGroup(group, e.target.checked, e)
                        }
                      />
                    )}
                    <span className={'group-name'}>{group.name}</span>
                  </div>
                }>
                {group.users.length > 0 ? (
                  group.users.map(user => {
                    const isUserChecked =
                      assigneePopupType &&
                      (isGroupChecked ||
                        selectUserData[assigneePopupType]?.some(
                          u => u.id === user.user.user_name.toString()
                        ))

                    return (
                      <div
                        className={'user-item'}
                        key={user.id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                        onClick={e => e.stopPropagation()}>
                        <Checkbox
                          checked={isUserChecked}
                          disabled={isGroupChecked || disabled}
                          onChange={e =>
                            handleSelectUser(user, group, e.target.checked, e)
                          }
                        />
                        <AvatarHasName
                          name={user.user.name_lowercase}
                          position={
                            user.user.department
                              ? convertCodeOrCodesToDepartName(user.user.department)
                              : convertCodeOrCodesToNameFromDepartUser(user.user.user_name)
                          }
                          imgId={user.image_id}
                        />
                      </div>
                    )
                  })
                ) : (
                  <div style={{ padding: '10px 0 10px 60px' }}>
                    <EmptyText>Không có người dùng</EmptyText>
                  </div>
                )}
              </PanelItem>
            )
          })}
        </Collapse>
      </div>
    </BoxWrapper>
  )
}

export default inject(
  'userStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'riskStore',
  'riskUnitUserStore',
  'departmentStore'
)(observer(SelectGroupBox))
